import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { useNavigationUtils } from '@/hooks/useNavigationUtils';
import DesktopServicesMegaMenu from './DesktopServicesMegaMenu';

interface DesktopNavigationProps {
  isServicesActive: boolean;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({ isServicesActive }) => {
  const { currentLanguage, getLocalizedPath } = useLanguage();
  const [isServicesMenuOpen, setIsServicesMenuOpen] = useState(false);
  const { 
    isWhyFutureLevelActive, 
    getWhyFutureLevelPath, 
    isPricingActive,
    getPricingPath
  } = useNavigationUtils();
  const t = translations[currentLanguage];
  
  return (
    <nav className="hidden md:flex items-center space-x-10 px-4">
      <Link 
        to={`/${currentLanguage}`}
        className="text-gray-100 hover:text-purple-400 transition-colors font-future text-sm tracking-wider relative group py-3"
      >
        <span className="uppercase font-medium">{t.home}</span>
        <span className="absolute -bottom-1 left-0 right-0 mx-auto w-0 h-[2px] bg-gradient-to-r from-purple-500 to-pink-500 group-hover:w-full transition-all duration-300"></span>
      </Link>
      
      {/* Services Mega Menu */}
      <DesktopServicesMegaMenu isOpen={isServicesMenuOpen} onToggle={setIsServicesMenuOpen} />
      
      <Link 
        to={getPricingPath()}
        className={`text-gray-100 hover:text-purple-400 transition-colors font-future text-sm tracking-wider relative group py-3 ${
          isPricingActive() ? 'text-purple-400' : ''
        }`}
      >
        <span className="uppercase font-medium">{t.pricing}</span>
        <span className={`absolute -bottom-1 left-0 right-0 mx-auto h-[2px] bg-gradient-to-r from-purple-500 to-pink-500 transition-all duration-300 ${
          isPricingActive() ? 'w-full' : 'w-0 group-hover:w-full'
        }`}></span>
      </Link>
      
      <Link 
        to={getWhyFutureLevelPath()}
        className={`text-gray-100 hover:text-purple-400 transition-colors font-future text-sm tracking-wider relative group py-3 ${
          isWhyFutureLevelActive() ? 'text-purple-400' : ''
        }`}
      >
        <span className="uppercase font-medium">{t.whyFutureLevel}</span>
        <span className={`absolute -bottom-1 left-0 right-0 mx-auto h-[2px] bg-gradient-to-r from-purple-500 to-pink-500 transition-all duration-300 ${
          isWhyFutureLevelActive() ? 'w-full' : 'w-0 group-hover:w-full'
        }`}></span>
      </Link>
      
      <Link 
        to={getLocalizedPath('blog')}
        className="text-gray-100 hover:text-purple-400 transition-colors font-future text-sm tracking-wider relative group py-3"
      >
        <span className="uppercase font-medium">{t.blog}</span>
        <span className="absolute -bottom-1 left-0 right-0 mx-auto w-0 h-[2px] bg-gradient-to-r from-purple-500 to-pink-500 group-hover:w-full transition-all duration-300"></span>
      </Link>
      
      <Link 
        to={getLocalizedPath('contact')}
        className="text-gray-100 hover:text-purple-400 transition-colors font-future text-sm tracking-wider relative group py-3"
      >
        <span className="uppercase font-medium">{t.contact}</span>
        <span className="absolute -bottom-1 left-0 right-0 mx-auto w-0 h-[2px] bg-gradient-to-r from-purple-500 to-pink-500 group-hover:w-full transition-all duration-300"></span>
      </Link>
    </nav>
  );
};

export default DesktopNavigation;